<template>
  <div class="forbidden">
    <Card>
      <template #title>
        <h1>403 - Forbidden</h1>
      </template>
      <template #subtitle>
        <p>You do not have permission to access this page.</p>
      </template>
      <template #content>
        <Button label="Go Back Home" icon="pi pi-home" @click="goHome" severity="primary"  />
      </template>
    </Card>
  </div>
</template>

<script>

export default {
  name: 'Forbidden',
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.forbidden {
  display: flex;
  justify-content: center;
  align-items: center;
}

h1 {
  color: #d9534f; /* Feel free to adjust the color theme */
}

p {
  margin: 0;
  font-size: 1.2em;
}
</style>